import React from 'react';
import PropTypes from 'prop-types';

// Utils
import { useTranslation } from 'react-i18next';
import withAuth from '../utils/hocs/withAuth';
import withSidebar from '../utils/hocs/withSidebar';

// Components
import PageWrapper from '../components/layout/PageWrapper/PageWrapper';
import AdministrationTable from '../components/tables/AdministrationTable/AdministrationTable';
import withPermission from '../utils/hocs/withPermission';
import SCOPE from '../utils/gate/scope';

function Admin({ children }) {
  const { t } = useTranslation();

  return (
    <PageWrapper
      title={t('admin.title')}
      hasWhiteWrapper
    >
      {children}
    </PageWrapper>
  );
}

Admin.propTypes = {
  children: PropTypes.node.isRequired,
};

export default withAuth(
  withPermission(
    withSidebar(Admin, {
      tabsBar: null,
      singleComponent: <AdministrationTable />,
    }),
    {
      scopes: [
        SCOPE.canGetAnyPlatformAdminAccount,
        SCOPE.canGetAnyEstablishmentAdminAccount,
        SCOPE.canGetAnyEstablishmentAdminAccountOOE,
      ],
    },
  ),
);
